import { AmazonUser, AmazonUserInfo } from "../AmazonUser";

export class MockAmazonUser implements AmazonUser {
  public userInfo: AmazonUserInfo = new MockAmazonUserInfo();
  public accessToken = "accessToken";
}

export class MockAmazonUserInfo implements AmazonUserInfo {
  public email = "foo@bar.com";
  public name = "foo";
  public postalCode = "44210";
  public accountId = "baz";
  public accessToken = "accessToken";
}
